import React from "react";
import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import FeaturesSection from "../components/FeaturesSection";
import AboutSection from "../components/AboutSection";
import ServicesSection from "../components/ServicesSection";
import CommitmentSection from "../components/CommitmentSection";
import GallerySection from "../components/GallerySection";
import TestimonialsSection from "../components/TestimonialsSection";
import CTASection from "../components/CTASection";
import ContactForm from "../components/ContactForm";
import LocationsSection from "../components/LocationsSection";
import Footer from "../components/Footer";
import WhatsAppButton from "../components/WhatsAppButton";

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <FeaturesSection />
      <AboutSection />
      <ServicesSection />
      <CommitmentSection />
      <GallerySection />
      <TestimonialsSection />
      <CTASection />
      <ContactForm />
      <LocationsSection />
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default Home;